import BaseAvatar from './Avatar';

// EXPORT
export const Avatar = BaseAvatar;
export type { AvatarProps } from './Avatar.interface';
